<template>
  <div v-if="outstandingCount > 0" class="alert alert-warning multi-register-banner mt-3">
    <p class="font-w600 mb-2">⚠ Multiple registers on this meter</p>

    <div class="mb-2">
      <div><strong>Meter:</strong> {{ meterName }}</div>
      <div v-if="meterIdentifier"><strong>MPAN/Serial:</strong> {{ meterIdentifier }}</div>
    </div>

    <ul class="register-checklist mb-2">
      <li v-for="row in rows" :key="row.value">
        <span class="tick" :class="{ done: row.done }">{{ row.done ? '✓' : '○' }}</span>
        {{ row.label }} — {{ row.done ? 'submitted' : 'still to submit' }}
      </li>
    </ul>

    <p class="mb-0 small">Please take a reading for each register.</p>
  </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue';
import type { RegisterRow } from '@/utils/registers';

const props = defineProps<{
  meterName: string;
  meterIdentifier: string | null;
  rows: RegisterRow[];
}>();

const outstandingCount = computed(() => props.rows.filter((row) => !row.done).length);
</script>

<style scoped>
.register-checklist {
  list-style: none;
  padding-left: 0;
}
.register-checklist li {
  padding: 2px 0;
}
.tick {
  display: inline-block;
  width: 1.2em;
  font-weight: 600;
}
.tick.done {
  color: #2e7d32;
}
</style>
